import { axiosInstance } from "./axiosInstance";

export const userService = {
    getUser: async ( filters ) => {
        return await axiosInstance.get('/api/superadmin/user', { params: filters })
    },
    exportUser: async (filter) => {
        return await axiosInstance.get('/api/superadmin/user', {
            params: { ...filter, is_export: true },
            responseType: 'blob'
        })
    },
}